"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishedState = void 0;
var PublishedState;
(function (PublishedState) {
    PublishedState["PUBLISHED"] = "PUBLISHED";
    PublishedState["UNPUBLISHED"] = "UNPUBLISHED";
    PublishedState["DRAFT"] = "DRAFT";
})(PublishedState = exports.PublishedState || (exports.PublishedState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVibGlzaGVkLXN0YXRlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kZWxzL3B1Ymxpc2hlZC1zdGF0ZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksY0FJWDtBQUpELFdBQVksY0FBYztJQUN4Qix5Q0FBdUIsQ0FBQTtJQUN2Qiw2Q0FBMkIsQ0FBQTtJQUMzQixpQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFKVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQUl6QiJ9